import * as types from '../actions/actionTypes';
import { assign } from '../shared/Assign';
import initialState from './initialState';
import ImpersonationStore from './../shared/ImpersonationStore';

export default function userReducer(state: any = initialState.user, action: any) {
    let newState;
    switch (action.type) {
        case types.LOGOUT_SUCCESS: {
            newState = assign({}, initialState.user);
            newState.impersonatedCountry = state.impersonatedCountry;
            newState.initialized = true;
            newState.signedOut = true;
            return newState;
        }
        case types.LOGIN_SUCCESS: {
            return {
                ...state,
                ...action.user
            };
        }
        case types.LOGIN_FAILED: {
            newState = assign({}, state);
            newState.initialized = true;
            return newState;
        }
        case types.RENEW_USER_SESSION: {
            return {
                ...state,
                ...action.user
            };
        }
        case types.IMPERSONATE_SUCCESS: {
            newState = assign({}, action.user);
            newState.impersonatedCountry = state.impersonatedCountry;
            newState.initialized = true;
            return newState;
        }
        case types.UNIMPERSONATE_SUCCESS: {
            newState = assign({}, action.user);
            newState.impersonatedCountry = state.impersonatedCountry;
            newState.initialized = true;
            return newState;
        }
        case types.IMPERSONATE_COUNTRY_SUCCESS: {
            newState = assign({}, state);
            newState.impersonatedCountry = action.country;
            return newState;
        }
        case types.UNIMPERSONATE_COUNTRY_SUCCESS: {
            newState = assign({}, state);
            newState.impersonatedCountry = null;
            return newState;
        }
        default:
            return state;
    }
}

export const getUser = (state) => state.user;
export const selectUserDetails = (state) => getUser(state).details;
export const selectUserCountry = (state) => selectUserDetails(state).country;
export const selectIsImpersonating = (state) => selectUserDetails(state).isImpersonated;
export const getUserInitialized = (state) => getUser(state).initialized;
export const getUserIsAuthenticated = (state) => getUser(state).isAuthenticated;
export const getUserImpersonation = () => ImpersonationStore.isImpersonated;
export const getUserImpersonatedCountry = (state) => getUser(state).impersonatedCountry;
